class GuideAnalytics {
    constructor() {
        const isEmployerSearchPage = document.querySelector('.guide-popular') !== null;
        if (!isEmployerSearchPage && window.pageType != "GuideSearch") return;

        this.addHeroLinkCTAEvent();
        this.addBranchSelectEvent();
        this.addAgreementSelectEvent();
        this.addSubmenuEvents();
        this.addTeaserBlockEvents();
        this.addSearchEvent();
    }

    addHeroLinkCTAEvent() {
        const ctaLink = document.querySelector('.hero-anchor');

        if (!ctaLink) return;

        ctaLink.addEventListener("click", () => {
            dataLayer.push({
                'event': 'arbetsgivareguidenCta'
            });
        })
    }

    addBranchSelectEvent() {
        const branchSelector = document.querySelector('.form__select--guide-branch-selector');

        if (!branchSelector) return;

        branchSelector.addEventListener('change', e => {
            const options = branchSelector.getElementsByTagName('option');
            const selectedBranch = options[branchSelector.selectedIndex];
            const selectedText = selectedBranch.innerText.trim();

            dataLayer.push({
                'event': 'arbetsgivareguidenSelectBranch',
                'arbetsgivarguidenSelectedBranch': selectedText.charAt(0).toUpperCase() + selectedText.slice(1).toLowerCase()
            });

        })
    }

    addAgreementSelectEvent() {
        const agreementSelector = document.querySelector('.form__select--guide-agreement-selector');

        if (!agreementSelector) return;

        agreementSelector.addEventListener('change', e => {
            const options = agreementSelector.getElementsByTagName('option');
            const selectedAgreement = options[agreementSelector.selectedIndex];
            const selectedText = selectedAgreement.innerText.trim();

            dataLayer.push({
                'event': 'arbetsgivareguidenSelectAgreement',
                'arbetsgivarguidenSelectedAgreement': selectedText
            });
        })
    }

    addSubmenuEvents() {
        const paneLinks = [...document.querySelectorAll('.pane-nav__links > li > a')];

        if (!paneLinks) return;

        paneLinks.forEach(element => {
            element.addEventListener('click', e => {
                const linkText = e.target.innerText.trim();

                dataLayer.push({
                    'event': 'arbetsgivarguidenSubmenuInteraction',
                    'arbetsgivarguidenSubmenuClickText': linkText
                });
            })
        })
    }

    addTeaserBlockEvents() {
        const teaserBlocksLinks = [...document.querySelectorAll('.block > .content-teaser-block > a')]

        if (!teaserBlocksLinks) return;

        teaserBlocksLinks.forEach(element => {
            element.addEventListener('click', e => {
                e.stopPropagation();

                const anchorTag = e.target.tagName !== "a" ? e.target.closest("a") : e.target;
                const linkText = anchorTag.querySelector('span').innerText;

                dataLayer.push({
                    'event': 'arbetsgivareguidenBanner',
                    'bannerClickText': linkText
                });
            });
        });
    }


    addSearchEvent() {
        const searchHeading = document.querySelector("input[type='search']");
        const form = [...document.querySelectorAll('form')].find(x => x.contains(searchHeading))

        if (!form) return;

        form.addEventListener('submit', () => {
            const searchTerm = searchHeading.value;
            dataLayer.push({
                'event': 'searchArbetsgivarguiden',
                'Search_term': searchTerm,
            });

        })
    }

}

document.addEventListener("DOMContentLoaded", () => new GuideAnalytics());
